export class Major {
    id : number;
    majorCode : string;
    majorName : string;
}